import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { 
  Home,
  Plus,
  CreditCard,
  AlertTriangle,
  CheckCircle,
  Users,
  BarChart3,
  LogOut,
  Menu,
  X
} from 'lucide-react';

const Sidebar = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsOpen(!mobile);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const closeSidebar = () => { if (isMobile) setIsOpen(false); };

  const userStr = localStorage.getItem('user');
  const loggedInUser = userStr ? JSON.parse(userStr) : null;
  const isHiba = loggedInUser?.email?.toLowerCase() === 'hiba@supemir.com';

  const handleNavigation = (path) => {
    navigate(path);
    closeSidebar();
  };

  const navigationItems = [
    { path: '/paiement-manager', label: 'Dashboard', icon: Home },
    { path: '/manager/ajouterPaiement', label: 'Nouveau Paiement', icon: Plus },
    { path: '/manager/listePaiement', label: 'Paiements', icon: CreditCard },
    { path: '/manager/paiementsExp', label: 'Paiements Exp.', icon: AlertTriangle },
    { path: '/manager/validation-paiement', label: 'Validation Paiement', icon: CheckCircle },
    { path: '/manager/etudiants-sans-prix', label: 'Étudiants Sans Prix', icon: Users },
    { path: '/etudiants-desistes', label: 'Étudiants Désistés', icon: Users },
    { path: '/manager/rapport-recouvrement', label: 'Rapport Recouvrement', icon: BarChart3 }
  ].filter(item => {
    if (isHiba) {
      return item.path === '/manager/listePaiement';
    }
    return true;
  });

  const sidebarStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '280px',
    height: '100vh',
    backgroundColor: '#ffffff',
    borderRight: '1px solid #e5e7eb',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
    zIndex: 999,
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',
  };

  const headerStyle = {
    padding: '24px 20px',
    background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontWeight: 'bold',
    fontSize: '1.25rem'
  };

  const navItemStyle = (active) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 16px',
    width: '90%',
    margin: '4px auto',
    border: 'none',
    background: active ? '#eef2ff' : 'transparent',
    color: active ? '#4f46e5' : '#6b7280',
    fontSize: '0.9rem',
    fontWeight: active ? '600' : '500',
    borderRadius: '12px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    textAlign: 'left'
  });

  const iconWrapperStyle = (active) => ({
    width: '32px',
    height: '32px',
    background: active ? '#c7d2fe' : '#f3f4f6',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  });

  return (
    <>
      <button 
        onClick={toggleSidebar}
        style={{
          position: 'fixed',
          top: '20px',
          left: isOpen && !isMobile ? '300px' : '20px',
          zIndex: 1001,
          background: '#4f46e5',
          color: 'white',
          border: 'none',
          padding: '12px',
          borderRadius: '12px',
          cursor: 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
          display: 'flex',
          transition: 'left 0.3s'
        }}
      >
        {isOpen ? <X size={20} /> : <Menu size={20} />}
      </button>

      {isMobile && isOpen && (
        <div 
          onClick={closeSidebar}
          style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.5)', zIndex: 998 }}
        />
      )}

      <div style={sidebarStyle}>
        <div style={headerStyle}>
          <div style={{ background: 'rgba(255,255,255,0.2)', padding: '6px', borderRadius: '8px' }}>
            <CreditCard size={20} />
          </div>
          Paiement Manager
        </div>

        <div style={{ flex: 1, padding: '20px 0', overflowY: 'auto' }}>
          {navigationItems.map((item) => (
            <button
              key={item.path}
              onClick={() => handleNavigation(item.path)}
              style={navItemStyle(location.pathname === item.path)}
            >
              <div style={iconWrapperStyle(location.pathname === item.path)}>
                <item.icon size={18} />
              </div>
              {item.label}
            </button>
          ))}
        </div>

        <div style={{ padding: '16px', borderTop: '1px solid #e5e7eb' }}>
          <button 
            onClick={onLogout}
            style={{ ...navItemStyle(false), color: '#dc2626' }}
          >
            <div style={{ ...iconWrapperStyle(false), background: '#fef2f2' }}>
              <LogOut size={18} color="#dc2626" />
            </div>
            Déconnexion
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
